import { useState } from 'react'
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';
import ContabilizzazioniService from '../services/ContabilizzazioniService/ContabilizzazioniService';

const useContabilizzazioni = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingContabilizzazioni: false,
    isLoadingContabilizzazioniByParams: false,
    isLoadingContabilizzazioneCreating: false,
  });

  const [modalState, setModalState] = useState({
    showModalCreateContabilizzazione: false,
    showModalDetailContabilizzazione: false
  });

  const getContabilizzazioniByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingContabilizzazioniByParams: true });
    try {
      let obj;
      let response = await ContabilizzazioniService.getContabilizzazioniByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingContabilizzazioniByParams: false });  
    }
  }

  const createContabilizzazione = async (data) => {
    setLoadingState({ ...loadingState, isLoadingContabilizzazioneCreating: true });
    try {
      const response = await ContabilizzazioniService.createContabilizzazione(data);
      alertService.success("Contabilizzazione creata con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateContabilizzazione: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingContabilizzazioneCreating: false });
    }
  }

  return {
    loadingStateContabilizzazioni: loadingState,
    modalStateContabilizzazioni: modalState,
    setModalStateContabilizzazioni: setModalState,
    getContabilizzazioniByParams,
    createContabilizzazione,
  };      
}

export default useContabilizzazioni;